export default __webpack_public_path__ + "static/media/Griefscale Leggings.83e73fde.jpg";